import { isPlatformBrowser } from '@angular/common';
import { Component, inject, Inject, PLATFORM_ID } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { OccConfig } from '@spartacus/core';

@Component({
    selector: 'app-kb-warranty-search-dialog',
    templateUrl: './kb-warranty-search-dialog.component.html',
    styleUrls: ['./kb-warranty-search-dialog.component.scss'],
    standalone: false
})
export class KbWarrantySearchDialogComponent {
  baseUrl: string = this.config?.backend?.occ?.baseUrl + '/';
  platformId = inject(PLATFORM_ID); 
  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: any,
    private dialogRef: MatDialogRef<KbWarrantySearchDialogComponent>,
    private config: OccConfig,
    public router :Router
  ) {
  }
  openPDF() {
    const url = this.baseUrl + this._data?.warrantyPdf?.url;
    if (isPlatformBrowser(this.platformId)) {
    window.open(url);
    }
  }
  
  navToSubmit() {
    this.router.navigate(['/submit-warranty'], {
      state: { warranty: this._data?.warranty }
    });
    this.dialogRef.close(true);
  }
}
  